import React from 'react';
import Puppy from '../../media/puppygrass.jpg';
import '../../css/Hero.css';

const Hero = () => {
  const handleDogRescueClick = () => {
    const targetUrl =
      'https://www.petfinder.com/search/dogs-for-adoption/?shelterRescue=fb77924f-58dc-4fe3-8a35-10fa4a6bb852';
    const newWindow = window.open(targetUrl, '_blank');
    if (newWindow) {
      // Security best practice: equivalent to rel="noopener"
      newWindow.opener = null;
    }
  };

  return (
    <div className="hero_container">
      <div className="hero_image">
        <img src={Puppy} alt="" />
      </div>
      <div className="hero_callToAction">
        <h1>Don't Shop</h1>
        <h3>Rescue Instead</h3>
        {/* <a href="/pets"> */}
        <button className="btn btn-warning" onClick={handleDogRescueClick}>
          AVAILABLE DOGS
        </button>
        {/* </a> */}
      </div>
    </div>
  );
};

export default Hero;
